<div class="container-fluid complyon-page assets-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell assets-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title assets-title mb-2 text-l">Asset register</h1>
      <p class="complyon-subtitle assets-subtitle mb-0 text-s">
        Physical and IT assets carrying a compliance obligation - insurance, maintenance, inspection or licensing - linked to location, controls and open issues.
      </p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'register'">
      <section class="mb-3">
        <div class="rounded-4 border px-3 py-3" style="background:#e8f8f5;border-color:#bce9df;">
          <div class="d-flex align-items-start gap-2 text-s">
            <i class="bi bi-shield-check mt-1 text-success"></i>
            <div>
              <strong>Assets as compliance records.</strong>
              Every asset is tracked for custody, maintenance, inspection, insurance and risk - with a complete evidence pack and a governed disposal workflow at end of life.
            </div>
          </div>
        </div>
      </section>

      <section class="row g-3 mb-3">
        <div v-for="card in register_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100" :class="card.label === 'In service' ? 'border border-info-subtle' : ''">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Asset register</div>
            <div class="complyon-section-subtitle text-xs">Total asset value tracked: R 50 910 000. Open an asset for its maintenance schedule, inspections, incidents and evidence pack.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action assets-action-btn" @click="open_asset_modal">
            <i class="bi bi-plus-lg"></i>
            <span>Add asset</span>
          </button>
        </div>

        <div class="px-3 pb-2 pt-2">
          <div class="d-flex flex-wrap align-items-center gap-1 mb-2">
            <button
              v-for="filter in register_filters"
              :key="filter.id"
              type="button"
              class="btn doa-tab-btn fw-semibold"
              :class="{ active: filter.active }"
            >
              <span>{{ filter.label }}</span>
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Ref</th>
                <th>Asset</th>
                <th>Category</th>
                <th>Location</th>
                <th>Value</th>
                <th>Risk</th>
                <th>Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in asset_rows"
                :key="row.ref"
                class="assets-table-row"
                role="button"
                tabindex="0"
                @click="open_asset_drawer(row)"
                @keydown.enter.prevent="open_asset_drawer(row)"
                @keydown.space.prevent="open_asset_drawer(row)"
              >
                <td class="ps-3"><div class="procurement-id">{{ row.ref }}</div></td>
                <td><div class="procurement-name">{{ row.asset }}</div></td>
                <td>{{ row.category }}</td>
                <td>{{ row.location }}</td>
                <td class="fw-semibold">{{ row.value }}</td>
                <td><span class="badge complyon-badge text-xs" :class="row.risk.class">{{ row.risk.label }}</span></td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right assets-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'maintenance'">
      <section class="row g-3 mb-3">
        <div v-for="card in maintenance_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Maintenance & inspection schedule</div>
            <div class="complyon-section-subtitle text-xs">Every scheduled service and statutory inspection across the asset base, overdue first. Open the asset to log completion.</div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Type</th>
                <th>Item</th>
                <th>Asset</th>
                <th>Due</th>
                <th>Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in maintenance_rows"
                :key="`${row.type}-${row.item}`"
                class="assets-table-row"
                :class="{ 'bg-light': row.highlighted }"
                role="button"
                tabindex="0"
                @click="open_asset_drawer(asset_ref_for_name(row.asset))"
                @keydown.enter.prevent="open_asset_drawer(asset_ref_for_name(row.asset))"
                @keydown.space.prevent="open_asset_drawer(asset_ref_for_name(row.asset))"
              >
                <td class="ps-3">{{ row.type }}</td>
                <td><div class="procurement-name">{{ row.item }}</div></td>
                <td>{{ row.asset }}</td>
                <td :class="row.due === 'Overdue' ? 'text-danger fw-semibold' : 'fw-semibold'">{{ row.due }}</td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right assets-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'disposals'">
      <section class="row g-3 mb-3">
        <div v-for="card in disposals_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Disposal workflow</div>
            <div class="complyon-section-subtitle text-xs">Governed end-of-life disposal - approval, data sanitisation, certified removal and evidence. Nothing leaves the register without a trail.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action assets-action-btn" @click="open_disposal_modal">
            <i class="bi bi-plus-lg"></i>
            <span>Log disposal</span>
          </button>
        </div>

        <div class="px-3 pb-2">
          <div
            v-for="row in disposal_rows"
            :key="row.ref"
            class="procurement-request d-flex flex-column gap-3 assets-disposal-row"
            role="button"
            tabindex="0"
            @click="open_disposal_edit_modal(row, disposal_rows.indexOf(row))"
            @keydown.enter.prevent="open_disposal_edit_modal(row, disposal_rows.indexOf(row))"
            @keydown.space.prevent="open_disposal_edit_modal(row, disposal_rows.indexOf(row))"
          >
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div class="min-w-0">
                <div class="procurement-request-title text-truncate">{{ row.ref }} - {{ row.asset }}</div>
                <div class="procurement-request-meta">{{ row.subtitle }}</div>
              </div>
              <span class="badge rounded-pill finance-badge" :class="row.status.class">{{ row.status.label }}</span>
            </div>

            <div class="d-flex align-items-center gap-2">
              <div
                v-for="(stage, index) in row.stages"
                :key="`${row.ref}-${stage}`"
                class="flex-grow-1 text-center"
              >
                <div
                  class="rounded-1 mx-auto"
                  :style="{
                    height: '4px',
                    width: '100%',
                    background: is_stage_active(index, row.active_stage) ? '#11827a' : '#dce3ea'
                  }"
                ></div>
                <div class="mt-2 text-xs" :class="is_stage_active(index, row.active_stage) ? 'text-success' : 'text-secondary'">{{ stage }}</div>
              </div>
            </div>

            <div class="procurement-request-meta">{{ row.route }}</div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-if="active_asset_drawer" class="command-centre-drawer-backdrop" @click="close_asset_drawer">
    <aside class="command-centre-drawer assets-drawer" role="dialog" aria-modal="true" :aria-label="active_asset_drawer.title" @click.stop>
      <header class="command-centre-drawer-header border-bottom">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="min-w-0">
            <div class="command-centre-drawer-kicker">{{ active_asset_drawer.section }}</div>
            <div class="command-centre-drawer-title mt-1">{{ active_asset_drawer.title }}</div>
            <div class="command-centre-drawer-subtitle mt-1">{{ active_asset_drawer.subtitle }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <span class="badge complyon-badge text-xs" :class="active_asset_drawer.status_class">{{ active_asset_drawer.status }}</span>
            <button type="button" class="btn btn-link p-0 assets-modal-close" @click="close_asset_drawer" aria-label="Close drawer">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </header>

      <div ref="assetDrawerBody" class="command-centre-drawer-body assets-drawer-body">
        <section class="mb-3">
          <div class="row g-2">
            <div class="col-6">
              <div class="command-centre-drawer-meta border rounded-3 p-3 h-100">
                <div class="command-centre-drawer-meta-label text-uppercase">Purchase value</div>
                <div class="command-centre-drawer-meta-value mt-1">{{ active_asset_drawer.purchase_value }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="command-centre-drawer-meta border rounded-3 p-3 h-100">
                <div class="command-centre-drawer-meta-label text-uppercase">Risk rating</div>
                <div class="assets-drawer-risk-title mt-1">{{ active_asset_drawer.risk_rating }}</div>
                <div class="assets-drawer-risk-bar mt-2">
                  <span :class="`is-${active_asset_drawer.risk_tone}`"></span>
                </div>
                <div class="assets-drawer-risk-score mt-2">{{ active_asset_drawer.risk_score }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="command-centre-drawer-meta border rounded-3 p-3 h-100">
                <div class="command-centre-drawer-meta-label text-uppercase">Warranty</div>
                <div class="command-centre-drawer-meta-value mt-1">{{ active_asset_drawer.warranty }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="command-centre-drawer-meta border rounded-3 p-3 h-100">
                <div class="command-centre-drawer-meta-label text-uppercase">Insurance</div>
                <div class="command-centre-drawer-meta-value mt-1">{{ active_asset_drawer.insurance }}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3 assets-drawer-metadata">
          <div class="row g-2">
            <div v-for="item in active_asset_drawer.metadata" :key="item.label" class="col-6">
              <div class="assets-drawer-meta-item">
                <div class="assets-drawer-meta-label">{{ item.label }}</div>
                <div class="assets-drawer-meta-value">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Compliance checklist</div>
            <div class="assets-drawer-progress-label">{{ active_asset_drawer.compliance_progress }}</div>
          </div>
          <div class="d-flex flex-column gap-2">
            <div v-for="item in active_asset_drawer.compliance" :key="item.title" class="assets-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="asset_tone_class(item.tone)">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0 flex-grow-1">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                </div>
                <span v-if="item.badge" class="badge complyon-badge text-xs" :class="item.badge_class">{{ item.badge }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Maintenance schedule</div>
            <button type="button" class="btn btn-link p-0 assets-drawer-add-btn text-decoration-none">
              <i class="bi bi-plus-lg"></i>
              <span>Add</span>
            </button>
          </div>
          <div class="d-flex flex-column gap-2">
            <div v-for="item in active_asset_drawer.maintenance" :key="item.title" class="assets-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="asset_tone_class(item.tone)">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0 flex-grow-1">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                </div>
                <span v-if="item.badge" class="badge complyon-badge text-xs" :class="item.badge_class">{{ item.badge }}</span>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Inspection records</div>
            <button type="button" class="btn btn-link p-0 assets-drawer-add-btn text-decoration-none">
              <i class="bi bi-plus-lg"></i>
              <span>Add</span>
            </button>
          </div>
          <div class="d-flex flex-column gap-2">
            <div v-for="item in active_asset_drawer.inspections" :key="item.title" class="assets-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="asset_tone_class(item.tone)">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0 flex-grow-1">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                </div>
                <span v-if="item.badge" class="badge complyon-badge text-xs" :class="item.badge_class">{{ item.badge }}</span>
              </div>
            </div>
          </div>
        </section>

        <section v-if="active_asset_drawer.incidents.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Incident history</div>
          <div class="d-flex flex-column gap-2">
            <div v-for="item in active_asset_drawer.incidents" :key="item.title" class="assets-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="asset_tone_class(item.tone)">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0 flex-grow-1">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="active_asset_drawer.connected_records.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Connected records</div>
          <div class="row g-2">
            <div v-for="record in active_asset_drawer.connected_records" :key="`${record.type}-${record.title}`" class="col-6">
              <div class="assets-drawer-linked-card">
                <div class="assets-drawer-linked-label">{{ record.type }}</div>
                <div class="assets-drawer-linked-value">{{ record.title }}</div>
                <div v-if="record.subtitle" class="assets-drawer-linked-subtitle">{{ record.subtitle }}</div>
                <button type="button" class="btn btn-link p-0 assets-drawer-linked-action" aria-label="Open linked record">
                  <i class="bi" :class="asset_icon_for_type(record.type)"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Asset evidence pack</div>
            <div class="assets-drawer-progress-label">{{ active_asset_drawer.evidence_progress }}</div>
          </div>
          <div class="d-flex flex-column gap-2">
            <div v-for="item in active_asset_drawer.evidence_pack" :key="item.title" class="assets-drawer-item">
              <div class="d-flex align-items-start gap-2">
                <span class="command-centre-drawer-item-icon" :class="asset_tone_class(item.tone)">
                  <i class="bi" :class="item.icon"></i>
                </span>
                <div class="min-w-0 flex-grow-1">
                  <div class="command-centre-drawer-item-title">{{ item.title }}</div>
                  <div class="command-centre-drawer-item-subtitle">{{ item.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="assets-drawer-recommendation">
          <div class="command-centre-drawer-section-title mb-2">Recommended action</div>
          <div class="assets-drawer-recommendation-copy">{{ active_asset_drawer.recommended_action }}</div>
        </section>
      </div>

      <footer class="command-centre-drawer-footer border-top assets-drawer-footer">
        <div class="d-flex align-items-center justify-content-between gap-2 w-100">
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn assets-drawer-secondary-btn">
              <i class="bi bi-trash3"></i>
              <span>Dispose</span>
            </button>
            <button type="button" class="btn assets-drawer-secondary-btn">
              <i class="bi bi-folder2-open"></i>
              <span>Evidence pack</span>
            </button>
          </div>
          <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2">
            <i class="bi bi-pencil-square"></i>
            <span>Edit asset</span>
          </button>
        </div>
      </footer>
    </aside>
  </div>

  <div v-if="asset_modal_open" class="assets-modal-backdrop" @click.self="close_asset_modal">
    <section class="assets-modal-shell" role="dialog" aria-modal="true" aria-label="New asset">
      <header class="assets-modal-header d-flex align-items-start justify-content-between gap-3 border-bottom">
        <div>
          <div class="assets-modal-title">New asset</div>
          <div class="assets-modal-subtitle">An asset carrying a compliance obligation. Maintenance, inspections and incidents are managed in the asset detail.</div>
        </div>
        <button type="button" class="btn btn-link p-0 assets-modal-close" @click="close_asset_modal" aria-label="Close modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="assets-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="assets-modal-label">Asset</label>
            <input v-model="asset_form.asset" type="text" class="form-control assets-modal-input" placeholder="e.g. Standby generator">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Category</label>
            <select v-model="asset_form.category" class="form-select assets-modal-input">
              <option v-for="option in asset_category_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Location</label>
            <input v-model="asset_form.location" type="text" class="form-control assets-modal-input" placeholder="e.g. Head office - Pretoria">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Owner / custodian</label>
            <input v-model="asset_form.owner" type="text" class="form-control assets-modal-input" placeholder="Name - role">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Serial / asset tag</label>
            <input v-model="asset_form.serial" type="text" class="form-control assets-modal-input" placeholder="Serial number">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Purchase value (R)</label>
            <input v-model="asset_form.purchase_value" type="text" class="form-control assets-modal-input">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Acquired</label>
            <input v-model="asset_form.acquired" type="text" class="form-control assets-modal-input" placeholder="e.g. 14 Aug 2024">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Supplier</label>
            <input v-model="asset_form.supplier" type="text" class="form-control assets-modal-input" placeholder="Supplier name or -">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Linked contract</label>
            <input v-model="asset_form.linked_contract" type="text" class="form-control assets-modal-input" placeholder="e.g. K-104 or -">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Warranty expiry</label>
            <input v-model="asset_form.warranty_expiry" type="text" class="form-control assets-modal-input" placeholder="e.g. 31 Aug 2027">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Insurance</label>
            <input v-model="asset_form.insurance" type="text" class="form-control assets-modal-input" placeholder="e.g. IN-01 - Property or -">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Risk rating</label>
            <select v-model="asset_form.risk_rating" class="form-select assets-modal-input">
              <option v-for="option in asset_risk_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Compliance status</label>
            <select v-model="asset_form.compliance_status" class="form-select assets-modal-input">
              <option v-for="option in asset_status_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12">
            <label class="assets-modal-label">Compliance note</label>
            <textarea v-model="asset_form.note" class="form-control assets-modal-textarea" rows="3" placeholder="Compliance context"></textarea>
          </div>
        </div>
      </div>

      <footer class="assets-modal-footer border-top d-flex align-items-center justify-content-end gap-2">
        <button type="button" class="btn btn-link text-decoration-none assets-modal-cancel" @click="close_asset_modal">Cancel</button>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="submit_asset_modal">
          <i class="bi bi-plus-lg"></i>
          <span>Create</span>
        </button>
      </footer>
    </section>
  </div>

  <div v-if="disposal_modal_open" class="assets-modal-backdrop" @click.self="close_disposal_modal">
    <section class="assets-modal-shell" role="dialog" aria-modal="true" :aria-label="disposal_edit_index === null ? 'New disposal' : 'Edit disposal'">
      <header class="assets-modal-header d-flex align-items-start justify-content-between gap-3 border-bottom">
        <div>
          <div class="assets-modal-title">{{ disposal_edit_index === null ? 'New disposal' : 'Edit disposal' }}</div>
          <div class="assets-modal-subtitle">An asset disposal moving through the governed disposal workflow.</div>
        </div>
        <button type="button" class="btn btn-link p-0 assets-modal-close" @click="close_disposal_modal" aria-label="Close modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="assets-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="assets-modal-label">Asset</label>
            <input v-model="disposal_form.asset" type="text" class="form-control assets-modal-input" placeholder="Asset ref - description">
          </div>

          <div class="col-12">
            <label class="assets-modal-label">Reason</label>
            <input v-model="disposal_form.reason" type="text" class="form-control assets-modal-input" placeholder="e.g. End of life / write-off">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Disposal method</label>
            <input v-model="disposal_form.method" type="text" class="form-control assets-modal-input" placeholder="e.g. Secure wipe + recycle">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Salvage / book value (R)</label>
            <input v-model="disposal_form.salvage_value" type="text" class="form-control assets-modal-input">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Approval route</label>
            <input v-model="disposal_form.approval_route" type="text" class="form-control assets-modal-input" placeholder="e.g. IT Manager → CFO">
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Stage</label>
            <select v-model="disposal_form.stage" class="form-select assets-modal-input">
              <option v-for="option in disposal_stage_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12 col-md-6">
            <label class="assets-modal-label">Status</label>
            <select v-model="disposal_form.status" class="form-select assets-modal-input">
              <option v-for="option in disposal_status_options" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>

          <div class="col-12">
            <label class="assets-modal-label">Note</label>
            <textarea v-model="disposal_form.note" class="form-control assets-modal-textarea" rows="3"></textarea>
          </div>
        </div>
      </div>

      <footer class="assets-modal-footer border-top d-flex align-items-center justify-content-between gap-2">
        <button
          v-if="disposal_edit_index !== null"
          type="button"
          class="btn btn-link text-decoration-none assets-modal-delete"
          @click="delete_disposal_modal"
        >
          <i class="bi bi-trash3"></i>
          <span>Delete</span>
        </button>
        <div v-else></div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-link text-decoration-none assets-modal-cancel" @click="close_disposal_modal">Cancel</button>
          <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2" @click="submit_disposal_modal">
            <i class="bi" :class="disposal_edit_index === null ? 'bi-plus-lg' : 'bi-check2'"></i>
            <span>{{ disposal_edit_index === null ? 'Create' : 'Save changes' }}</span>
          </button>
        </div>
      </footer>
    </section>
  </div>
</div>
